import React, { useState } from "react";
import Reports from "./Reports";
import LabReport from "./LabReport";

function UploadReport(props) {
  const [selectedOption, setSelectedOption] = useState("Report");
  const selectedPatient = props.selectedPatient;

  const handleOptionChange = (option) => {
    setSelectedOption(option);
    if (option == "Report") {
    }
  };

  return (
    <div>
      <div className="lg:w-[100%] xl:w-[50%] w-full lg:m-auto m-0 xl:m-auto flex justify-center items-center cursor-pointer rounded-full bg-white">
        <div
          className={`rounded-full md:px-8 px-4 py-3  font-bold text-base md:text-base text-xs ${
            selectedOption == "Report"
              ? "bg-secondaryColor text-white"
              : "text-gray-600"
          }`}
          onClick={() => handleOptionChange("Report")}
        >
          Report
        </div>
        <div
          className={`rounded-full md:px-8 px-4 py-3  font-bold text-base md:text-base text-sm ${
            selectedOption == "LabReport"
              ? "bg-secondaryColor text-white"
              : "text-gray-600"
          }`}
          onClick={() => handleOptionChange("LabReport")}
        >
          Lab Report
        </div>
      </div>
      <div className="w-[95%] m-auto mt-5">
        {selectedOption === "Report" && selectedPatient && (
          <div className="">
            <Reports selectedPatient={selectedPatient}/>
          </div>
        )}
        {selectedOption === "LabReport" && selectedPatient && (
          <div className="">
            <LabReport selectedPatient={selectedPatient}/>
          </div>
        )}
      </div>
    </div>
  );
}

export default UploadReport;
